import { AppTheme, BREAKPOINTS_CONFIG, SxProps } from '@cp/ds/src/theme';
import { CONTAINER_HORIZONTAL_SPACING, CONTAINER_MAX_WIDTH } from '@cp/ds/src/components/container/const';
import { Breakpoint } from '@mui/material';
import React from 'react';

export const CATALOG_DESKTOP_COLUMN_WIDTH_FIXED = 270;
export const CATALOG_DESKTOP_ITEM_CARD_WIDTH_MAX = 460;
export const CATALOG_DESKTOP_COLUMN_SPACING = 2.5;
export const CATALOG_MOBILE_COLUMN_SPACING = 1;

const calcItemListStylesForBP = (
  breakpoints: Breakpoint[],
  { theme, widthModifierForMainBlock = 0 }: { theme: AppTheme; widthModifierForMainBlock?: number },
): { containerSx: SxProps; cardWidthAutoUntilBreakpoint: Breakpoint } => {
  const CONTAINER_SPACINGS_COUNT = 2;
  const containerMaxWidth: Partial<Record<Breakpoint, React.CSSProperties['maxWidth']>> = {
    xs: 'none',
  };
  let cardWidthFullUntilBreakpoint: Breakpoint | undefined;
  const columnSpacing = parseInt(theme.spacing(CATALOG_DESKTOP_COLUMN_SPACING));

  for (const bp of breakpoints) {
    const screenWidth = BREAKPOINTS_CONFIG[bp];
    const containerPadding = parseInt(theme.spacing(CONTAINER_HORIZONTAL_SPACING[bp])) * CONTAINER_SPACINGS_COUNT;
    const mainBlockWidth = screenWidth - containerPadding - widthModifierForMainBlock;

    const itemListColumns = mainBlockWidth / (CATALOG_DESKTOP_COLUMN_WIDTH_FIXED + columnSpacing);
    const itemListColumnsRounded = Math.floor(itemListColumns);

    if (!screenWidth || itemListColumnsRounded === 1) {
      containerMaxWidth[bp] = CATALOG_DESKTOP_ITEM_CARD_WIDTH_MAX;
    } else {
      if (!cardWidthFullUntilBreakpoint) {
        cardWidthFullUntilBreakpoint = bp;
      }

      containerMaxWidth[bp] =
        (itemListColumnsRounded * CATALOG_DESKTOP_COLUMN_WIDTH_FIXED) +
        ((itemListColumnsRounded - 1) * columnSpacing);
    }
  }

  return { containerSx: { mx: 'auto', maxWidth: containerMaxWidth }, cardWidthAutoUntilBreakpoint: cardWidthFullUntilBreakpoint ?? 'xs' };
};

export const calcDesktopItemListStyles = (
  theme: AppTheme,
  parameters: Omit<Parameters<typeof calcItemListStylesForBP>[1], 'theme'> = {
    widthModifierForMainBlock: CATALOG_DESKTOP_COLUMN_WIDTH_FIXED,
  },
) => {
  return calcItemListStylesForBP(['md', 'lg', 'xl'], { theme, ...parameters });
};

export const calcMobileItemListStyleParams = (theme: AppTheme) => {
  const COLUMNS_COUNT_MIN = 2;
  const columnSpacing = parseInt(theme.spacing(CATALOG_MOBILE_COLUMN_SPACING));
  const MAIN_BLOCK_WIDTH_MIN = (COLUMNS_COUNT_MIN * CATALOG_DESKTOP_COLUMN_WIDTH_FIXED) + ((COLUMNS_COUNT_MIN - 1) * columnSpacing);

  let screenWidthMaxForSingleColumn = 0;

  for (const bp of ['xs', 'sm', 'md'] as Breakpoint[]) {
    const containerMaxWidth = CONTAINER_MAX_WIDTH[bp];
    const screenWidthMaxForCurrentBP = MAIN_BLOCK_WIDTH_MIN <= containerMaxWidth ? BREAKPOINTS_CONFIG[bp] : 0;

    screenWidthMaxForSingleColumn = screenWidthMaxForSingleColumn
      ? Math.min(screenWidthMaxForSingleColumn, screenWidthMaxForCurrentBP)
      : screenWidthMaxForCurrentBP;
  }

  return { screenWidthMaxForSingleColumn, columnSpacing };
};
